<template>
  <div>
    <div class="header">
      <input type="text" v-model="keyWords">
      <el-button type="primary" class="search" @click="searchKeyWords">搜索</el-button>
      <el-button type="primary" @click="send">发布</el-button>
    </div>
   
    <div class="content clearfix">

      <div class="postList">
        <h3>最新内容</h3>
        <PostList :keyWords="keyWords" ref="postList"></PostList>
      </div>

      <div class="hotSearch">
        <h3>热门话题</h3>
        <HotSearchList :hotSearchList="hotSearchList"></HotSearchList>
      </div>

      <div class="rules">
        <p>用户指南 · 
          <router-link to="/navigator/bbs/bbsRules">
          用户协议
          </router-link>  · 应用 · 工作
        </p>
        <p>侵权举报网上有害信息举报专区</p>
        <p>违法和不良信息举报： 0755-82716601</p>
        <p>儿童色情信息举报专区</p>
        <p>联系我们 © 2018 SMARK</p>
      </div>
    </div>


     <!-- 弹窗登录 -->
    <MaskLogin v-show='showLogin' @close='showLogin = false;'></MaskLogin>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HotSearchList from './HotSearchList';
import PostList from './PostList';

export default {
  data() {
    return {
      keyWords: '',
      hotSearchList: [],
      showLogin: false,
    }
  },
  methods: {
    goSearch() {
      console.log(this.search);
    },
    getHotSearchList() {  // 获取热搜列表
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/hotlist`, {
        parkId: this.currentParkId,
        currPage: 1,
        pageRows: 6,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.hotSearchList = res.resData.pageList ? res.resData.pageList : [];
        }
      });
    },
    searchKeyWords() {  // 搜索
      this.$refs.postList.getPostList();
    },
    send() {  // 发布
      if (this.token) {
        this.$router.push({ path: '/navigator/bbs/sendPost' })
      } else {
        this.showLogin = true;
      }
    },
  },
  components: {
    HotSearchList, PostList
  },
  computed: {
    ...mapGetters(['currentParkId', 'token']),
  },
  mounted() {
    this.getHotSearchList();
  },
}
</script>


<style lang="scss" scoped>
@import '~@scss';

.header {
  display: flex;
  justify-content: space-between;
  input {
    width: 640px;
    padding: 10px;
    border: 1px solid $color-main;
  }
  .el-button {
    width: 380px;
  }
  .search {
    width: 140px;
    border-radius: 0;
    margin-left: -10px;
  }
}
.content {
  margin-top: 30px;
  margin-bottom: 40px;
  h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
  }
  .postList {
    width: 800px;
    min-height: 300px;
    float: left;
    margin-right: 20px;
  }
  .hotSearch {
    float: left;
    width: 380px;
    min-height: 300px;
  }
  .rules {
    float: right;
    width: 360px;
    margin-top: 16px;
    margin-left: 4px;
    p {
      font-size: 14px;
      color: #666;
      a {
        color: #666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/bbs/microCommunity/MicroCommunity.vue